import { Suspense, lazy } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { ChakraProvider, Spinner, Center } from '@chakra-ui/react';

// Theme
import theme from './theme';

// Context
import { AppProvider } from './context/AppContext';
import { LanguageProvider } from './context/LanguageContext';

// Components
import Layout from './components/layout/Layout';
import ErrorBoundary from './components/ErrorBoundary/ErrorBoundary';
import NotificationSystem from './components/Notifications/NotificationSystem';
import CookieBanner from './components/CookieBanner/CookieBanner';

// Lazy loaded components
const Article = lazy(() => import('./pages/article/article'));
const Biography = lazy(() => import('./pages/biography/biography'));
const Blog = lazy(() => import('./pages/blog/blog'));
const Book = lazy(() => import('./pages/books/book'));
const BookList = lazy(() => import('./pages/books/bookList'));
const CookiesPolicy = lazy(() => import('./pages/policies/cookiesPolicy'));
const Contact = lazy(() => import('./pages/contact/contact'));
const Home = lazy(() => import('./pages/home/home'));
const LegalWarning = lazy(() => import('./pages/policies/legalWarning'));
const NotFound = lazy(() => import('./pages/notFound'));
const Paintings = lazy(() => import('./pages/paintings/paintings'));
const Painting = lazy(() => import('./pages/paintings/painting'));
const PrivacyPolicy = lazy(() => import('./pages/policies/privacyPolicy'));

// Loading component
const LoadingSpinner = () => (
    <Center h="100vh">
        <Spinner
            thickness="4px"
            speed="0.65s"
            emptyColor="gray.200"
            color="brand.main"
            size="xl"
        />
    </Center>
);

function App() {
    return (
        <ErrorBoundary>
            <LanguageProvider>
                <AppProvider>
                    <ChakraProvider theme={theme}>
                        <div className="App">
                            <NotificationSystem />
                            <BrowserRouter>
                                <CookieBanner />
                                <Suspense fallback={<LoadingSpinner />}>
                                    <Routes>
                                        <Route path="/" element={<Layout />}>
                                            <Route path="/aviso-legal" element={<LegalWarning />} />
                                            <Route path="/biografia" element={<Biography />} />
                                            <Route path="/blog" element={<Blog />} />
                                            <Route path="/blog/:link" element={<Article />} />
                                            <Route path="/contacto" element={<Contact />} />
                                            <Route path="/libros" exact element={<BookList />} />
                                            <Route path="/libros/:id" element={<Book />} />
                                            <Route path="/pinturas" element={<Paintings />} />
                                            <Route path="/pinturas/:id" element={<Painting />} />
                                            <Route path="/politica-de-cookies" element={<CookiesPolicy />} />
                                            <Route path="/politica-de-privacidad" element={<PrivacyPolicy />} />
                                            <Route path="/" element={<Home />} />
                                        </Route>
                                        <Route path="*" element={<NotFound />} />
                                    </Routes>
                                </Suspense>
                            </BrowserRouter>
                        </div>
                    </ChakraProvider>
                </AppProvider>
            </LanguageProvider>
        </ErrorBoundary>
    );
}

export default App;
